import * as React from 'react'

function SvgFrostResistant(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={31} height={31} viewBox="0 0 17 17" {...props}>
			<path
				fill="currentColor"
				d="M8.071 7.703h.934l.455.79-.428.742h-.939l-.5-.743zm.445 7.105l.538-.348v-1.678l.932.528.48-.24v-.624l-1.39-.79V10.55l.984.601v-1.1l1.027.585v1.587l.488.278.501-.278v-1.046l1.386.79.601-.275v-.657l-1.417-.84.891-.5v-.569l-.458-.322-1.415.792-1.004-.528.975-.562-.948-.59.977-.62 1.415.838.481-.265v-.598l-.924-.517 1.474-.84v-.62l-.528-.325-1.506.815V4.681l-.514-.225-.49.225v1.73l-1.012.55v-1.2l-.985.6V5.258l1.44-.814v-.528l-.488-.32-.973.534V2.457l-.538-.35-.54.35V4.13l-.937-.525-.477.276v.586l1.391.791v1.103l-1.036-.555.006 1.14-.987-.56.004-1.617-.539-.313-.444.3v1.078l-1.465-.847-.574.294v.67l1.487.808-.933.526v.61l.518.256 1.38-.808.952.551-.95.588.98.561.022.02-.956.551-1.38-.81-.542.296v.614l.958.481-1.536.841v.67l.625.261 1.464-.824v1.061l.443.296.53-.329V10.59l.964-.556v1.168l1.01-.65v1.104l-1.392.791v.591l.477.273.937-.528v1.678z"
			/>
		</svg>
	)
}

export default SvgFrostResistant
